import React from 'react';
import { ISimpleLocation } from '@lialo/core/lib/models';
import { useDialogState } from '@lialo/pwa-ui/lib/useDialogState';
import { ConfirmationDialog } from '@lialo/pwa-ui/lib/ConfirmationDialog';
import { useTranslation } from 'react-i18next';
import routes from '@lialo/core/lib/pages/utils/routes';

interface IProps {
  location?: ISimpleLocation;
  button: React.ReactElement<{ onClick: () => void }>;
  dialogText: string;
  mode: 'location' | 'route';
}

const GoogleMapsLink = (props: IProps) => {
  const { t } = useTranslation();
  const { button, location, mode } = props;

  const navigateToGoogleMaps = React.useCallback(
    (confirmed: boolean) => {
      if (confirmed && location) {
        const url = routes.generateGoogleMapsLink(location.lat, location.lng, mode);
        closeDialog();
        window.open(url, '_blank')?.focus();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location, mode]
  );

  const [isDialogOpen, openDialog, closeDialog] = useDialogState(navigateToGoogleMaps);

  return (
    <>
      {React.cloneElement(button, { onClick: openDialog })}
      <ConfirmationDialog
        description={props.dialogText}
        confirmationLabel={t('actions.open')}
        cancelLabel={t('actions.cancel')}
        onClose={closeDialog}
        open={isDialogOpen}
      />
    </>
  );
};

export default GoogleMapsLink;
